<!--
  Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->

<br/>
<h1 class="page-header">GPS RPO Management</h1>
@if (permission()) {
  <div>
    <table style="width: 100%;">
      <tr>
        <td>
          <p-confirmDialog key="updateUserConfirmation"></p-confirmDialog>
          <p-confirmDialog key="missingGpsRposConfirmation"></p-confirmDialog>
        </td>
        <td>
          <div class="buttons pull-right">
            @if (adminPermission()) {
              <p-button label="Save All Changes" (click)="saveGpsRpos()" icon="pi pi-save"
                [disabled]="!dataChanged || duplicate || rowsInvalid"
              [loading]="!!(saving || exporting || resetting)" class="gm-btn-primary mr-2"></p-button>
            }
            <p-button icon="pi pi-download" (onClick)="exportReport()"
            label="Download Report" class="gm-btn-primary mr-2"></p-button>
            @if (adminPermission()) {
              <p-button label="Reset Changes" (click)="resetChanges()"
                [loading]="!!(saving || exporting || resetting)"
              severity="warn" icon="pi pi-replay"></p-button>
            }
          </div>
        </td>
      </tr>
    </table>
    <p-confirmDialog key="deleteRowConfirmation"></p-confirmDialog>
    <ag-grid-angular style="width: 100%; height: 80vh;" class="ag-theme-balham"
      [undoRedoCellEditing]="true" [enableCellTextSelection]="true"
      (cellEditingStopped)="cellEditingStopped($event, rowData)"
      [undoRedoCellEditingLimit]="50" [columnDefs]="cols" [rowData]="rowDataSignal()"
      [defaultColDef]="defaultColDef" [autoSizeStrategy]="autoSizeStrategy"
      (gridReady)="onGridReady($event)" [rowHeight]="60" [paginationPageSize]="50"
    [pagination]="true" [rowClassRules]="rowClassRules"></ag-grid-angular>
  </div>
}








